import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { ImageComponent } from '@libs/common/components';
import { HeroVideoContentModel } from '@libs/cms/models';
import { HtmlDataLinkDirective } from '@libs/shared/ui';
import { HeadlinesComponent } from '../../items';
import { ContentBaseComponent } from '../content-base.component';
import { VideoContentPlayerComponent } from '../video-content/video-content-player';

@Component({
  selector: 'ui-hero-video',
  templateUrl: './hero-video.component.html',
  styleUrls: [
    './hero-video.component.scss',
    './hero-video.component.lekkerland-2026.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImageComponent,
    HeadlinesComponent,
    HtmlDataLinkDirective,
    VideoContentPlayerComponent,
  ],
  host: {
    '[class]': '"background-" + data().view.background',
  },
})
export class HeroVideoComponent extends ContentBaseComponent<HeroVideoContentModel> {
  public readonly hasPlaybackError: WritableSignal<boolean> = signal(false);

  public handlePlaybackError(): void {
    this.hasPlaybackError.set(true);
  }
}
